import { useI18n } from "./hooks/use.i18n";

export const useTextInputLocalization = () => {
  const tTextInput = useI18n("TEXT_INPUT.");

  return {
    PASSWORD_VISIBILITY: tTextInput("TOGGLE_PASSWORD_VISIBILITY"),
    CLEAR: tTextInput("CLEAR"),
  };
};
